import PropTypes from "prop-types";
import React from "react";

const productImageGallerySticky = ({ product }) => {
  return (
    <div className="product-large-image-wrapper product-large-image-wrapper--sticky">
      {(product && product.discount) || (product && product.new) ? (
        <div className="product-img-badges">
          {product.discount ? (
            <span className="purple" style={{ fontSize: "18px" }}>
              -{product && product.discount}%
            </span>
          ) : (
            ""
          )}
          {product.new ? <span className="pink">New</span> : ""}
        </div>
      ) : (
        ""
      )}
      <div className="product-sticky-image mb--10">
        {product &&
          product.images &&
          product.images.map((single, key) => {
            return (
              <div className="product-sticky-image__single mb-10" key={key}>
                <img
                  src={`https://yonetim.minyatursepeti.com/images/products/${
                    product.name &&
                    product.name.replace(/ /g, "_").replace(":", ".")
                  }/${single.imageName}`}
                  alt=""
                  className="img-fluid"
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

productImageGallerySticky.propTypes = {
  product: PropTypes.object,
};

export default productImageGallerySticky;
